<template>
  <el-table
    :data="data"
    border
    style="min-width: 100%"
  >
    <el-table-column
      label="序号"
      width="80"
    >
      <template #default="scope">
        <span>{{ scope.row && scope.row.serial }}</span>
      </template>
    </el-table-column>
    <!-- <el-table-column
      label="产品名"
      width="240"
    >
      <template #default="">
        <span>麦苗守护权益兑换</span>
      </template>
    </el-table-column> -->
    <el-table-column
      label="产品名称"
      width="300"
    >
      <template #default="scope">
        <span>{{ scope.row && scope.row.product_name }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="权益兑换码"
      width="150"
    >
      <template #default="scope">
        <span>{{ scope.row && scope.row.activation_code }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="链接"
      min-width="200"
    >
      <template #default="scope">
        <div class="name-wrapper">
          <el-tag class="link-tag">
            <a
              class="share-link"
              target="_blank"
              :href="scope.row && scope.row.share_link"
            >
              {{ scope.row && scope.row.share_link }}
            </a>
          </el-tag>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="免费天数"
      width="100"
      prop="exchange_days"
    />
    <el-table-column
      label="上架状态"
      width="100"
    >
      <template #default="scope">
        <el-switch
          :value="scope.row.status?true:false"
          @click="handleSwitch( scope && scope.row)"
        />
      </template>
    </el-table-column>
    <!-- <el-table-column
      label="操作"
      width="100"
    >
      <template #default="scope">
        <el-button
          size="mini"
          @click="handleEdit(scope && scope.row)"
        >
          编辑
        </el-button>
      </template>
    </el-table-column> -->
  </el-table>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, watch, reactive, toRefs } from 'vue'
import { requestStatus } from '@/apis/spread'
import { SpreadLink } from '@/model/spreadOrder'
import { ElMessage, ElMessageBox } from 'element-plus'
// import requestMiddle, { RequestInter } from '@/utils/request'
interface LinkData{
    handleSwitch: (row: Row) => void
    handleEdit: (row: Row) => void
    mergeArray: number[]
    currentData: Array<SpreadLink<SpreadLink<string | number>>>
    pos: number
}
interface Row{
  id: Number
  status: Boolean
}
export default defineComponent({
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  emits: ['reFresh'],
  setup(props: any) {
    const data: LinkData = reactive({
      mergeArray: [],
      currentData: [],
      pos: 0,
      handleEdit(row: Row) {
        (this as any).$router.push({ path: '/spread/edit', query: { id: row && row.id } })
      },
      handleSwitch: async(row: Row) => {
        // 上架状态变下架就弹出提示
        row?.status && ElMessageBox.alert('链接已下架!')
        requestStatus({
          id: row && row.id, status: row && !row.status
        }).then((res) => {
          if (res?.code === 200) {
            row && (row.status = !row.status)
          } else {
            ElMessage.warning(res?.msg)
          }
        })
      },
      mergeSameRow({ rowIndex, columnIndex }: {row: any, column: any, rowIndex: number, columnIndex: number}) {
        if (columnIndex === 1 || columnIndex === 3 || columnIndex === 4) {
          const _row: number = data.mergeArray[rowIndex]
          const _col: number = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
      }
    })

    watch(() => props.data, (now) => {
      data.currentData = now
      const list: Array<SpreadLink<SpreadLink<string | number>>> = props.data
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          data.mergeArray.push(1)
          data.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          // 根据相同id进行合并,根据需要可进行修改
          if (list[i].share_link === list[i - 1].share_link) {
            data.mergeArray[data.pos] += 1
            data.mergeArray.push(0)
          } else {
            data.mergeArray.push(1)
            data.pos = i
          }
        }
      }
    })
    onBeforeMount(() => {
      console.log(props.data)
    })
    return { ...toRefs(data) }
  }
})
</script>
<style lang="scss" scoped>
.share-link{
  &:hover{
    text-decoration: underline;
  }
}
.name-wrapper{
  .link-tag{
    height: auto !important;
    white-space:normal;
  }
}
</style>
